import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getUsers = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/users?' + params.toString()); // Let the error bubble up
};

const getUserById = async (id: number) => {
  return await apiClient.get(`/users/${id}`); // Fetch car listing by ID
};

const createUser = async (userData: any) => {
  return await apiClient.post('/users', userData); // Create a new car listing
};

const updateUser = async (id: number, userData: any) => {
  return await apiClient.patch(`/users/${id}`, userData); // Update car listing by ID
};

const deleteUser = async (id: number) => {
  return await apiClient.delete(`/users/${id}`); // Delete car listing by ID
};

export default {
  getUsers,
  getUserById,
  createUser,
  updateUser,
  deleteUser,
};
